import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [];

@NgModule({
  imports: [
    RouterModule.forRoot([
      { path: '', redirectTo: '/app', pathMatch: 'full' },
      { path: 'app', component: AdminComponent,  },
      { path: 'login', component: LoginComponent }
    ], { useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
